module.exports = __webpack_public_path__ + "img/08.14d683f9.png";